import { Outlet } from "react-router-dom";
import { Footer } from "../components/footer";
import { Header } from "../components/header";
import { MobileBottomNav } from "../components/mobile-bottom-nav";

export function RootLayout() {
  return (
    <div className="relative min-h-screen pb-28 md:pb-0">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
